import { Link, useNavigate } from 'react-router-dom';
import Header from '../dt/dt';
import Pagination from '../dt/Pagination';
import empty_table from '../../assets/images/empty_table.png';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearMessage } from '../../slices/messages';
import { deleteAd, myAd } from '../../slices/advertisements';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

const MyAdvertisement = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { messageStatus } = useSelector((state) => state.message);
    const { advertisements } = useSelector((state) => state.advertisement);
    const { user } = useSelector((state) => state.auth);

    const { t, i18n } = useTranslation();

    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';
    const [activeLang, setActiveLang] = useState(currentLang);

    const [currentPage, setCurrentPage] = useState(1);
    const [defaultSort, setSort] = useState({ 'sort_column': 'created_at', 'sort_type': 'desc' });
    const [search, setSearch] = useState("");

    let PageSize = 10;

    let tmpVar = {
        page: currentPage,
        sort: defaultSort,
        activeLang: activeLang,
        search: search
    };

    const [successMsg, setSuccessMsg] = useState(false);

    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }

        if (messageStatus == "Success") {    
            setSuccessMsg(true);
        }

        dispatch(clearMessage());

        let tmpVar = {
            page: currentPage,
            sort: defaultSort,
            activeLang: activeLang,
            search: search
        };

        dispatch(myAd(tmpVar));
    }, [defaultSort, currentPage, search]);

    const changePageSize = (pageNumber) => {
        setSort({ 'sort_column': 'created_at', 'sort_type': 'desc' });
        setCurrentPage(pageNumber);
    }

    const columns_data = [
        {
            key: "image",
            text: t('image'),
            className: "",
            align: "left",
            sortable: false,
            defaultSort: false,
        },
        {
            key: "title_" + activeLang,
            text: t('title'),
            className: "",
            align: "left",
            sortable: true,
            defaultSort: false,
        },
        {
            key: "created_at",
            text: t('createdAt'),
            className: "",
            align: "left",
            sortable: true,
            defaultSort: false,
        },
        {
            key: "status",
            text: t('status'),
            className: "",
            sortable: false,
            defaultSort: 'asc',
        },
        {
            key: "expire_at",
            text: t('expireAt'),
            className: "",
            sortable: true,
            defaultSort: 'asc',
        },
        {
            key: "action",
            text: t("action"),
            className: "",
            sortable: false,
            align: "left",
            defaultSort: false,
        }
    ];

    const [columns, setColumns] = useState(columns_data);

    const clickaction = (column, type, index) => {
        setSort({ 'sort_column': column, 'sort_type': type });
    }

    const searchValue = (e) => {
        setSearch(e.target.value);
    }

    const deleteItem = (id) => {
        Swal.fire({
            title: t('delete_confirm'),
            showDenyButton: false,
            showCancelButton: true,
            icon: 'success',
            confirmButtonText: t('delete'),
            cancelButtonText: t('cancel'),
            allowOutsideClick: true,
            confirmButtonColor: "#61B653"
        }).then(function (result) {
            if (result.isConfirmed) {
                dispatch(deleteAd(id)).unwrap()
                    .then(() => {
                        let tmpVar = {
                            page: currentPage,
                            sort: defaultSort,
                            activeLang: activeLang,
                            search: search
                        };

                        dispatch(myAd(tmpVar));
                        Swal.fire({
                            title: t('Advertisement_post'),
                            showDenyButton: false,
                            showCancelButton: false,
                            icon: 'success',
                            confirmButtonText: t('okay'),
                            allowOutsideClick: true,
                            confirmButtonColor: "#61B653"
                        });
                    })
                    .catch((e) => {

                    });
            } else {

            }
        });
    }

    return (
        <div className="container">
            <section className="mt-5 pt-5">
                <div className="row">
                    <div className='col-md-6'>
                        <div className='section-title' id="heading_title">
                            <h1><span className='font-color-1'>{t('my_advertisements')}</span></h1>
                            <p className='mb-0'>{t('here_advrt')}</p>
                        </div>
                    </div>
                    <div className='col-md-6 table-search-area mt-5'>
                        <div className='table-search'>
                            <input type='search' className='form-control' placeholder={t('search_here')} onChange={e => searchValue(e)} />
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </div>
                        <div className='table-search-btn'>
                            <Link to="/create-advertisement" className='btn btn-primary'>{t('create_advertisement')}</Link>
                        </div>
                    </div>
                    <div className='col-md-12 mt-2-5'>
                    { successMsg &&
                            <div className="col-md-12 error-section">
                                <div className="alert alert-success" role="alert" > {t('advertisement_save')} </div> 
                            </div>
                        }
                        <div className='table-area bg-2 font-color'>
                            <div className='table-responsive'>
                                <table className='table '>
                                    <Header config={columns} handleClick={clickaction} defaultSort={defaultSort} />
                                    <tbody>
                                        {
                                            advertisements != null && advertisements.total > 0 ?
                                            advertisements?.res.map((item, index) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <td><img src={item.image_path} width="60" /></td>
                                                            <td>{item.title}</td>
                                                            <td>{item.created_at}</td>
                                                            <td>{item.status == 0 ? t('pending') : t('approved')}</td>
                                                            <td>{item.expire_at ? item.expire_at : t('not_approve_yet')}</td>
                                                            <td className='d-flex'>
                                                                <Link to={`/advertisement/edit/${item.id}`} className='btn btn-primary btn-sm'><i className='fa fa-pencil'></i></Link>
                                                                <button className='btn btn-primary btn-sm ms-2' onClick={() => deleteItem(item.id)}><i className='fa fa-trash'></i></button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                                :
                                                <tr>
                                                    <td colSpan={6} className='text-center'>
                                                        <div className='emptyTable'>
                                                            <img src={empty_table} />
                                                            <h5 className='mt-2-new'>{t('noData')}</h5>
                                                        </div>
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12'>
                        <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            totalCount={advertisements ? advertisements.total : 1}
                            pageSize={PageSize}
                            onPageChange={page => changePageSize(page)}
                        />
                    </div>

                </div>
            </section>
        </div>
    );
}
export default MyAdvertisement;